export default {
	state: {
		participante: {}
	},
	getters: {
		"participante": state => state.participante
	},
	mutations: {
		setParticipante(state, payload) {
			state.participante = payload
		}
	},
	actions: {
		atualizarEstadoParticipante({ commit }, payload) {
			commit('setParticipante', payload)
		}
	}
};